<input type="text" #inputText
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [maxLength]="3" [tabindex]="tabindex"
  plessInputTextSub [restrict]="'[0-9]'" [halfOnly]="true"
  [(ngModel)]="textValue" (ngModelChange)="changeIconCodeHandler()"
  (blur)="onFocusOut($event);" [autofocus]="autofocus" [disabled]="disabled" />
